"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Countries = void 0;
var Countries = {
  CA: {
    label: 'Social Insurance Number',
    placeholder: '000-000-000',
    format: function format(numbers) {
      if (numbers.length >= 4 && numbers.length < 7) {
        return "".concat(numbers.substr(0, 3), "-").concat(numbers.substr(3));
      }

      if (numbers.length > 6) {
        return "".concat(numbers.substr(0, 3), "-").concat(numbers.substr(3, 3), "-").concat(numbers.substr(6));
      }

      return numbers;
    }
  },
  US: {
    label: 'Social Security Number',
    placeholder: '000-00-0000',
    format: function format(numbers) {
      if (numbers.length >= 4 && numbers.length < 6) {
        return "".concat(numbers.substr(0, 3), "-").concat(numbers.substr(3));
      }

      if (numbers.length > 5) {
        return "".concat(numbers.substr(0, 3), "-").concat(numbers.substr(3, 2), "-").concat(numbers.substr(5));
      }

      return numbers;
    }
  },
  AUS: {
    label: 'ABN',
    placeholder: '00 000 000 000',
    format: function format(numbers) {
      if (numbers.length >= 3 && numbers.length < 6) {
        return "".concat(numbers.substr(0, 2), " ").concat(numbers.substr(2));
      }

      if (numbers.length >= 6 && numbers.length < 9) {
        return "".concat(numbers.substr(0, 2), " ").concat(numbers.substr(2, 3), " ").concat(numbers.substr(5));
      }

      if (numbers.length > 8) {
        return "".concat(numbers.substr(0, 2), " ").concat(numbers.substr(2, 3), " ").concat(numbers.substr(5, 3), " ").concat(numbers.substr(8));
      }

      return numbers;
    }
  }
};
exports.Countries = Countries;